<template lang="pug">
.item.d-flex.flex-column.align-items-center
  img(:src="img")
  h5 {{ title }}
  p.i_body_l {{ subtitle }}
</template>

<script>
export default {
  name: "Item",
  props: {
    title: String,
    subtitle: String,
    img: String,
  },
};
</script>

<style lang="scss" scoped>
.item {
  padding-top: 50px;
}

img {
  @include square(180px);
}

h5 {
  @include font(22px, $color_blue_ci, 500);
  text-align: center;
  margin-top: 20px;
}

p {
  text-align: center;
  margin-top: 10px;
}

@media (max-width: 991px) {
  .item {
    padding-top: 45px;
  }

  img {
    @include square(151px);
  }

  h5 {
    font-size: 18px;
  }

  p {
    margin-top: 17px;
    font-size: 16px;
  }
}

@media (max-width: 767px) {
  .item {
    padding-top: 30px;
  }

  img {
    @include square(130px);
  }

  h5 {
    font-size: 24px;
    margin-top: 10px;
  }

  p {
    margin-top: 10px;
    font-size: 20px;
  }
}

@media (max-width: 575px) {
  .item {
    padding-top: 5.2vw;
  }

  img {
    @include square(22.5vw);
  }

  h5 {
    font-size: 4.2vw;
    margin-top: 1.7vw;
  }

  p {
    margin-top: 1.7vw;
    font-size: 3.5vw;
  }
}
</style>
